export enum FileDestinationEnum {
	User = 'User',
	Event = 'Event',
	PrototypeUser = 'PrototypeUser',
	PrototypeMarket = 'PrototypeMarket',
	PrototypeEvent = 'PrototypeEvent',
	PrototypeFeaturedImage = 'PrototypeFeaturedImage',
	PrototypeChat = 'PrototypeChat',
	PrototypeLobby = 'PrototypeLobby',
	Export = 'Export',
	Courses = 'Courses',
}

export const FileDestinationArray = Object.values(FileDestinationEnum);
